import {
  FocusLayer as FocusLayerComponent,
  type FocusLayerSizeValue,
  type WithFocusLockProps,
  withFocusLock,
} from '@volkswagen-onehub/components-core';
import {
  type FocusLayerOptionsV2,
  FocusLayerSizeV2,
  type LayerV2,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';
import ReactDOM from 'react-dom';

import {LayerContent} from './layer-content';

export interface FocusLayerProps {
  readonly layer: LayerV2<unknown, FocusLayerOptionsV2>;
  readonly active: boolean;
  scrollElementRef(el: HTMLDivElement): void;
}

const layerSizeMap: {[key in FocusLayerSizeV2]: FocusLayerSizeValue} = {
  [FocusLayerSizeV2.A]: 'A',
  [FocusLayerSizeV2.B]: 'B',
  [FocusLayerSizeV2.C]: 'C',
  [FocusLayerSizeV2.NONE]: 'none',
};

const Layer: React.FunctionComponent<FocusLayerProps> = (props) => {
  const {layer, active, scrollElementRef, ...ownProps} = props;
  const {options} = layer;

  return (
    <FocusLayerComponent
      {
        ...ownProps /* Used to pass through the animation props */
      }
      header={options.header}
      footer={options.footer}
      size={layerSizeMap[options.size]}
      aria-labelledby={layer.options['aria-labelledby']}
      active={active}
      scrollElementRef={(el: HTMLDivElement) => {
        scrollElementRef(ReactDOM.findDOMNode(el) as HTMLDivElement);
      }}
    >
      <LayerContent layer={layer} />
    </FocusLayerComponent>
  );
};

const FocusLayerWithLock = withFocusLock<FocusLayerProps>(Layer);
FocusLayerWithLock.displayName = 'FocusLayerWithLock';

export const FocusLayer: React.ElementType = (
  props: FocusLayerProps & WithFocusLockProps,
) => {
  return <FocusLayerWithLock {...props} disabled={props.layer.isClosed} />;
};
